import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Archive24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.63776 9.54444C5.05479 9.54444 5.39286 9.88272 5.39286 10.3V17.4778C5.39286 17.8785 5.55197 18.2629 5.83519 18.5463C6.1184 18.8297 6.50253 18.9889 6.90306 18.9889H17.0969C17.4975 18.9889 17.8816 18.8297 18.1648 18.5463C18.448 18.2629 18.6071 17.8786 18.6071 17.4778V10.3C18.6071 9.88272 18.9452 9.54444 19.3622 9.54444C19.7793 9.54444 20.1173 9.88272 20.1173 10.3V17.4778C20.1173 18.2793 19.7991 19.048 19.2327 19.6148C18.6663 20.1816 17.898 20.5 17.0969 20.5H6.90306C6.102 20.5 5.33375 20.1816 4.76731 19.6148C4.20087 19.048 3.88265 18.2793 3.88265 17.4778V10.3C3.88265 9.88272 4.22072 9.54444 4.63776 9.54444Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3.30291 4.05324C3.65693 3.69901 4.13709 3.5 4.63776 3.5H19.3622C19.8629 3.5 20.3431 3.69901 20.6971 4.05324C21.0511 4.40748 21.25 4.88792 21.25 5.38889V7.65556C21.25 8.07284 20.9119 8.41111 20.4949 8.41111H3.5051C3.08807 8.41111 2.75 8.07284 2.75 7.65556V5.38889C2.75 4.88792 2.94889 4.40748 3.30291 4.05324ZM4.63776 5.01111C4.53762 5.01111 4.44159 5.05091 4.37079 5.12176C4.29998 5.19261 4.2602 5.2887 4.2602 5.38889V6.9H19.7398V5.38889C19.7398 5.2887 19.7 5.19261 19.6292 5.12176C19.5584 5.05091 19.4624 5.01111 19.3622 5.01111H4.63776Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8.82855 10.9926C8.82855 10.5753 9.16662 10.237 9.58365 10.237H14.4163C14.8333 10.237 15.1714 10.5753 15.1714 10.9926C15.1714 11.4099 14.8333 11.7481 14.4163 11.7481H9.58365C9.16662 11.7481 8.82855 11.4099 8.82855 10.9926Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
